import Vue from 'vue'
import Vuex from 'vuex'

import { account } from './account.module'
import { documents } from './documents.module'
import { moduleMaterialTypes } from './moduleMaterialTypes.module'
import { navigation } from './navigation.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    account,
    documents,
    moduleMaterialTypes,
    navigation,
  }
})

export default store
